addEventListener('DOMContentLoaded', () => {
    const productGrids = document.querySelectorAll('.featured-collection-grid');

    if (productGrids && productGrids.length > 0) {
      productGrids.forEach((productGrid) => {
        if (productGrid.dataset.maxItems > 4) setFlickity(productGrid);
      });
    }
});

function setFlickity(productGrid) {
  const flkty = new Flickity(productGrid, {
    freeScroll: true,
    wrapAround: true,
    cellAlign: 'left',
    groupCells: 1,
    lazyLoad: true,
    arrowShape: {
      x0: 10,
      x1: 60,
      y1: 50,
      x2: 75,
      y2: 35,
      x3: 40
    },
    on: {
        ready: function() {
            setTimeout(() => {
                this.resize();
                updateSlideFocusability(productGrid);
            }, 500);
        },
        change: function() {
            updateSlideFocusability(productGrid);
        }
    }
  });
  const pageDotsContainer = productGrid.querySelector('.flickity-page-dots');

  if (!pageDotsContainer) return;

  const [...pageDots] = pageDotsContainer.children;

  if (!pageDots.length) return;

  let pageWidth = 370;
  if (window.matchMedia('(max-width: 425px)').matches) {
    const gridWidth = productGrid.clientWidth || window.innerWidth;
    pageWidth = Math.min(200, gridWidth - 84);
  }
  const dotWidth = Math.max(12, pageWidth / pageDots.length - pageDots.length / 2);
  pageDots.forEach((dot) => {
    dot.style.width = `${dotWidth}px`;
  });
}

function updateSlideFocusability(container) {
  const slides = container.querySelectorAll('.product__grid-item');
  slides.forEach(function(slide) {
    const isHidden = slide.getAttribute('aria-hidden') === 'true';
    const focusables = slide.querySelectorAll('a, button, input, select, textarea, [tabindex]');
    focusables.forEach(function(el) {
      if (isHidden) {
        el.setAttribute('tabindex', '-1');
      } else {
        el.removeAttribute('tabindex');
      }
    });
  });
}
